import login from './lib/login'
import logout from './lib/logout'
import getWpsSid from './lib/get-wps-sid.js'

export default {
  login,
  logout,
  getWpsSid
}
